import triggerEvent from 'ant-design-vue/es/_util/triggerEvent'
import { inBrowser } from 'ant-design-vue/es/_util/env'

const getComponentFromProp = (instance, prop) => {
  // Vue 3 兼容：instance 可能是 content 对象
  if (!instance) return undefined
  
  // 尝试从 slots 获取
  if (instance.slots) {
    const slots = typeof instance.slots === 'function' ? instance.slots() : instance.slots
    if (slots && slots[prop]) {
      return slots[prop]
    }
  }
  
  // 尝试从 props 获取
  if (instance.props && instance.props[prop]) {
    return instance.props[prop]
  }
  
  // 尝试从 attrs 获取（Vue 3）
  if (instance.attrs && instance.attrs[prop]) {
    return instance.attrs[prop]
  }
  
  // 尝试直接从 instance 获取（Vue 2 兼容）
  if (instance[prop]) {
    return instance[prop]
  }
  
  return undefined
}

const isFun = (func) => {
  return typeof func === 'function'
}

// 兼容 0.3.4~0.3.8
export const contentWidthCheck = (contentWidth) => {
  return Object.prototype.toString.call(contentWidth) === '[object Boolean]'
    ? (contentWidth === true && 'Fixed') || 'Fluid'
    : contentWidth
}

export const layoutContentWidth = (contentType) => {
  return contentType !== 'Fluid'
}

const themeConfig = {
  daybreak: 'daybreak',
  '#1890ff': 'daybreak',
  '#F5222D': 'dust',
  '#FA541C': 'volcano',
  '#FAAD14': 'sunset',
  '#13C2C2': 'cyan',
  '#52C41A': 'green',
  '#2F54EB': 'geekblue',
  '#722ED1': 'purple',
}

const invertKeyValues = (obj) =>
  Object.keys(obj).reduce((acc, key) => {
    acc[obj[key]] = key
    return acc
  }, {})

/**
 * #1890ff -> daybreak
 * @param val
 */
export function genThemeToString(val) {
  return val && themeConfig[val] ? themeConfig[val] : val
}

/**
 * daybreak-> #1890ff
 * @param val
 */
export function genStringToTheme(val) {
  const stringConfig = invertKeyValues(themeConfig)
  return val && stringConfig[val] ? stringConfig[val] : val
}

export { triggerEvent, inBrowser, getComponentFromProp, isFun }
